<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-form ref="templateForm">
        <v-card class="pa-3">
          <v-card-title>
            <h3>基本信息</h3>
            <span v-show="status==='readonly'">
              <v-btn flat color="primary" @click="status='edit'">修改</v-btn>
            </span>
          </v-card-title>
          <v-layout column>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="模板名称" prepend-icon="$vuetify.icons.title" :readonly="status==='readonly'" v-model="form.name"
                :rules="[$rules.requiredS()]">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="执行路径" prepend-icon="$vuetify.icons.location" :readonly="status==='readonly'" v-model="form.execPath"
                              :rules="[$rules.requiredS()]">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-autocomplete
                  :readonly="status==='readonly'"
                  :items="form.orgSelect"
                  v-model="form.org"
                  v-on:keyup="getOrgs"
                  prepend-icon="$vuetify.icons.org"
                  label="所属分组"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :rule="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该分组信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <!--<span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>-->
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :disabled="form.org===''"
                  :readonly="status==='readonly'"
                  :items="form.groupSelect"
                  v-model="form.group"
                  v-on:keyup="getRuleGroups"
                  prepend-icon="$vuetify.icons.org"
                  label="所属分类"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :rule="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该分类信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                     <!-- <span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>-->
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-textarea rows="1" label="模板描述" auto-grow prepend-icon="$vuetify.icons.comment" :readonly="status==='readonly'" v-model="form.description">
              </v-textarea>
            </v-layout>
          </v-layout>
        </v-card>
        <v-card class="pa-3 mt-3">
          <v-card-title>
            <h3>常量参数配置</h3>
            <v-btn flat color="primary" @click="addConstantParam()" :disabled="status==='readonly'">添加参数</v-btn>
          </v-card-title>
          <v-layout column>
            <v-layout v-for="(p,index) in form.constantParams" :key="index" column>
              <v-layout>
                <v-flex xs6>
                  <v-text-field label="参数key" v-model="p.key" prepend-icon="$vuetify.icons.code" :readonly="status==='readonly'"
                                :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="参数名称" v-model="p.name" prepend-icon="$vuetify.icons.title" :readonly="status==='readonly'"
                                :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs7>
                  <v-text-field label="参数描述" v-model="p.desc" prepend-icon="$vuetify.icons.comment" :readonly="status==='readonly'"
                                :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-select :items="paramTypeSelect" item-text="name" item-value="value" v-model="p.type" label="参数类型" prepend-icon="$vuetify.icons.details"
                            :rules="[$rules.requiredS()]" :readonly="status==='readonly'">
                  </v-select>
                </v-flex>
                <v-flex xs1 class="pt-2">
                  <v-btn flat color="error" @click="deleteConstantParam(index)" :disabled="status==='readonly'">删除</v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout justify-center>
              <v-btn icon :disabled="status==='readonly'" @click="addConstantParam()">
                <v-icon color="primary">{{$vuetify.icons.add}}</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card>
        <v-card class="pa-3 mt-3">
          <v-card-title>
            <h3>变量参数配置</h3>
            <v-btn flat color="primary" @click="addVariableParam" :disabled="status==='readonly'">添加参数</v-btn>
          </v-card-title>
          <v-layout column>
            <v-layout v-for="(p,index) in form.variableParams" :key="index" column>
              <v-layout>
                <v-flex xs6>
                  <v-text-field label="参数key" v-model="p.key" prepend-icon="$vuetify.icons.code" :readonly="status==='readonly'"
                                :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="参数名称" v-model="p.name" prepend-icon="$vuetify.icons.title" :readonly="status==='readonly'"
                                :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs7>
                  <v-text-field label="参数描述" v-model="p.desc" prepend-icon="$vuetify.icons.comment" :readonly="status==='readonly'"
                                :rules="[$rules.requiredS()]">
                  </v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-select :items="paramTypeSelect" item-text="name" item-value="value" v-model="p.type" label="参数类型" prepend-icon="$vuetify.icons.details"
                            :readonly="status==='readonly'" :rules="[$rules.requiredS()]">
                  </v-select>
                </v-flex>
                <v-flex xs1 class="pt-2">
                  <v-btn flat color="error" @click="deleteVariableParam(index)" :disabled="status==='readonly'">删除</v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
        </v-card>
        <v-layout justify-center v-show="status==='edit'||status==='new'">
          <v-btn class="primary" @click="(status==='new')?submit():update()" :loading="loading">提交</v-btn>
        </v-layout>
      </v-form>
    </v-card>
  </l-layout>
</template>
<script>
export default{
  name: 'ruleTemplate',
  props: {
    statusProp: {
      type: String,
      default: 'new'
    },
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      form: {
        name: '',
        description: '',
        org: '',
        orgSelect: [],
        group: '',
        groupSelect: [],
        constantParams: [
        ],
        variableParams: [],
        execPath: ''
      },
      loading: false,
      status: '',
      paramTypeSelect: [
        {name: 'String', value: 'string'},
        {name: 'Boolean', value: 'boolean'},
        {name: 'Int', value: 'int'},
      ]
    }
  },
  created () {
    this.initViewProp()
    this.initFormData()
  },
  methods: {
    initViewProp () {
      this.status = this.statusProp
    },
    initFormData () {
      if (this.status === 'new') {
        return
      }
      // console.log(this.formData)
      this.form.name = this.formData.name
      this.form.execPath = this.formData.execPath
      this.form.description = this.formData.description
      this.form.groupSelect.push(this.formData.classifications[0])
      this.form.group = this.formData.classifications[0]
      this.dealFormOrg(this.formData.obgrpId)
      let constantParams = JSON.parse(this.formData.constantParamDefinitions)
      let variableParams = JSON.parse(this.formData.variableParamDefinitions)
      for (let p in constantParams) {
        let obj = constantParams[p]
        obj.key = p
        this.form.constantParams.push(obj)
      }
      for (let p in variableParams) {
        let obj = variableParams[p]
        obj.key = p
        this.form.variableParams.push(obj)
      }
    },
    async dealFormOrg (id) {
      let res = await this.$store.dispatch('charging/getOrgs', {name: '', id: id})
      if (res.data.status === 1) {
        this.form.orgSelect = res.data.data.content
        this.form.org = res.data.data.content[0]
      }
      else {
        this.form.orgSelect = []
      }
    },
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    addConstantParam () {
      let obj = {
        name: '',
        description: '',
        key: '',
        type: ''
      }
      this.form.constantParams.push(obj)
    },
    deleteConstantParam (index) {
      this.form.constantParams.splice(index, 1)
    },
    addVariableParam () {
      let obj = {
        name: '',
        description: '',
        key: '',
        type: ''
      }
      this.form.variableParams.push(obj)
    },
    deleteVariableParam (index) {
      this.form.variableParams.splice(index, 1)
    },
    async getOrgs (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let res = await this.$store.dispatch('charging/getOrgs', {name: search, id: ''})
      if (res.data.status === 1) {
        this.form.orgSelect = res.data.data.content
      }
      else {
        this.form.orgSelect = []
      }
    },
    async getRuleGroups (data) {
      let search = (data === undefined) ? '' : data.target.value
      let {items, amount} = await this.$store.dispatch('charging/getRuleGroup', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'name', value: search}})
      this.form.groupSelect = items
      return {items, amount}
    },
    async submit () {
      if (this.$refs.templateForm.validate()) {
        let constantParamDefinitions = {}
        let variableParamDefinitions = {}
        for (let i = 0; i < this.form.constantParams.length; i++) {
          let item = this.form.constantParams[i]
          constantParamDefinitions[item.key] = {
            name: item.name,
            desc: item.desc,
            type: item.type
          }
        }
        for (let i = 0; i < this.form.variableParams.length; i++) {
          let item = this.form.variableParams[i]
          variableParamDefinitions[item.key] = {
            name: item.name,
            desc: item.desc,
            type: item.type
          }
        }
        let params = {
          name: this.form.name,
          description: this.form.description,
          obgrpId: this.form.org,
          constantParamDefinitions: constantParamDefinitions,
          variableParamDefinitions: variableParamDefinitions,
          example: {},
          execPath: this.form.execPath,
          ruleClassiId: this.form.group,
          creator: this.getUserInfo().name
        }
        this.loading = true
        let res = await this.$store.dispatch('charging/addRuleTemplate', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.$L.alert('success', {message: '添加成功'})
          this.status = 'readonly'
        }
        else {
          this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    },
    async update () {
      if (this.$refs.templateForm.validate()) {
        let constantParamDefinitions = {}
        let variableParamDefinitions = {}
        for (let i = 0; i < this.form.constantParams.length; i++) {
          let item = this.form.constantParams[i]
          constantParamDefinitions[item.key] = {
            name: item.name,
            desc: item.desc,
            type: item.type
          }
        }
        for (let i = 0; i < this.form.variableParams.length; i++) {
          let item = this.form.variableParams[i]
          variableParamDefinitions[item.key] = {
            name: item.name,
            desc: item.desc,
            type: item.type
          }
        }
        let params = {
          id: this.formData.id,
          name: this.form.name,
          description: this.form.description,
          obgrpId: (this.form.org instanceof Object) ? this.form.org.id : this.form.org,
          constantParamDefinitions: constantParamDefinitions,
          variableParamDefinitions: variableParamDefinitions,
          example: {},
          execPath: this.form.execPath,
          ruleClassiId: (this.form.group instanceof Object) ? this.form.group.id : this.form.group,
          lastEditor: this.getUserInfo().name
        }
        this.loading = true
        let res = await this.$store.dispatch('charging/updateRuleTemplate', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.$L.alert('success', {message: '更新成功'})
          this.status = 'readonly'
        }
        else {
          this.$L.alert('error', {message: '更新失败，原因：' + res.data.msg})
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
      }
    }
  }
}
</script>
